import React from "react";
import { Box, Text, Link } from "gestalt";

function Caption({ products }) {
  return (
    <Box padding={3} position="absolute" bottom left>
      <Text color="white">
        {products.map((item, index) => {
          return (
            <Link key={index} href={item.url}>
              <b>{item.name}</b>, ${item.price}
            </Link>
          );
        })}
      </Text>
    </Box>
  );
}

export default Caption;



// WEBPACK FOOTER //
// ./src/Components/caption.js